<template>
    <div class="center">
        <div class="sidebar-container">
            <el-menu
                    ref="newsMenu"
                    active-text-color="#ffd04b"
                    background-color="#545c64"
                    class="el-menu-vertical-demo"
                    :default-active="activeMenu"
                    text-color="#fff"
                    :collapse="isCollapse"
                    @open="handleOpen"
                    @close="handleClose"
                    @select="handleSelect"
            >
<!--                <el-sub-menu index="1">-->
<!--                    <template #title>-->
<!--                        <el-icon><location /></el-icon>-->
<!--                        <span>Navigator One</span>-->
<!--                    </template>-->
<!--                    <el-menu-item-group>-->
<!--                        <template #title><span>Group One</span></template>-->
<!--                        <el-menu-item index="1-1">item one</el-menu-item>-->
<!--                        <el-menu-item index="1-2">item two</el-menu-item>-->
<!--                    </el-menu-item-group>-->
<!--                    <el-menu-item-group title="Group Two">-->
<!--                        <el-menu-item index="1-3">item three</el-menu-item>-->
<!--                    </el-menu-item-group>-->
<!--                    <el-sub-menu index="1-4">-->
<!--                        <template #title><span>item four</span></template>-->
<!--                        <el-menu-item index="1-4-1">item one</el-menu-item>-->
<!--                    </el-sub-menu>-->
<!--                </el-sub-menu>-->
<!--                <el-menu-item index="2">-->
<!--                    <el-icon><icon-menu /></el-icon>-->
<!--                    <template #title>Navigator Two</template>-->
<!--                </el-menu-item>-->
                <el-menu-item index="3">
                    <el-icon><document /></el-icon>
                    <template #title>新闻添加</template>
                </el-menu-item>
                <el-menu-item index="4">
                    <el-icon><document /></el-icon>
                    <template #title>新闻管理</template>
                </el-menu-item>
<!--                <el-menu-item index="4">-->
<!--                    <el-icon><setting /></el-icon>-->
<!--                    <template #title>Navigator Four</template>-->
<!--                </el-menu-item>-->
            </el-menu>
        </div>
        <div class="main-container">
            <div v-show="showIndex === '3'" class="app-container">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="新闻标题">
                        <el-col :span="11">
                            <el-input v-model="form.title" />
                        </el-col>
                    </el-form-item>
<!--                    <el-form-item label="新闻类型">-->
<!--                        <el-select v-model="form.region" placeholder="please select your zone">-->
<!--                            <el-option label="Zone one" value="shanghai" />-->
<!--                            <el-option label="Zone two" value="beijing" />-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item label="新闻日期">
                        <el-col :span="5">
                            <el-date-picker v-model="form.pubTime" type="date" placeholder="选择新闻日期" value-format="YYYY-MM-DD 00:00:00" style="width: 100%;" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="新闻摘要">
                        <el-input v-model="form.zhaiyao" type="textarea" />
                    </el-form-item>
                    <el-form-item label="新闻内容">
                        <!--        <TinymceEditor v-model="form.noticeContent" ref="tinymceEditorRef"></TinymceEditor>-->
                        <div style="border: 1px solid #ccc;">
                            <MyEditor ref="editor" toolbarConfig="toolbarConfig"></MyEditor>
<!--                            <Toolbar-->
<!--                                    style="border-bottom: 1px solid #ccc"-->
<!--                                    :editor="editor"-->
<!--                                    :defaultConfig="toolbarConfig"-->
<!--                                    :mode="mode"-->
<!--                            />-->
<!--                            <Editor-->
<!--                                    style="height: 500px; overflow-y: hidden;"-->
<!--                                    v-model="html"-->
<!--                                    :defaultConfig="editorConfig"-->
<!--                                    :mode="mode"-->
<!--                                    @onCreated="onCreated"-->
<!--                            />-->
                        </div>
                    </el-form-item>
                    <el-form-item label="封面图片">
                        <el-upload
                                ref="imageRef"
                                :http-request="upimage"
                                :file-list="fileList"
                                list-type="picture-card"
                                :on-change="handleChange"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove">
<!--                            <img v-if="imageBase64" :src="imageBase64" class="avatar" width="100" height="100" />-->
                            <el-icon v-if="!imageBase64" class="avatar-uploader-icon"><Plus /></el-icon>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button v-show="!isEdit" type="primary" @click="onSubmit">添加</el-button>
                        <el-button v-show="isEdit" type="primary" @click="onSave">保存</el-button>

                        <el-button v-show="isEdit" @click="onCancel">删除</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="showIndex === '4' && newsList" class="news-manage-container">
                <div class="news-list">
                    <div v-if="newsList" v-for="(item, index) in newsList">
                        <div class="news-item">
                            <div class="news-date">
                                <div style="font-weight: bold; font-size: 50px">
                                    {{item.date}}
                                </div>
                                <div>
                                    {{item.month}}
                                </div>
                            </div>
                            <div class="news-info" @click="handleClick(item.id)">
                                <div class="news-info-title">
                                    {{item.title}}
                                </div>
                                <div class="news-info-text">
                                    {{item.zhaiyao}}
                                </div>
                            </div>
                            <div class="news-img">
                                <img style="height: 100%;object-fit: contain;" :src=item.img alt="">
                            </div>
                        </div>

                        <div v-if="index !== newsList.length - 1" class="bottom-line"></div>

                    </div>

                </div>
                <div class="pagination">
                    <el-pagination
                            v-model:current-page="currentPage"
                            :page-size="100"
                            layout="prev, pager, next"
                            :total="1000"
                            @current-change="handleCurrentChange"
                            align="center"
                            background/>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import MyEditor from "@/components/MyEditor.vue";
import {ref} from "vue";
import {getNews, getNewsImage, getNewsList, removeNews, submitNews, updateNews, upload} from "@/api/user";
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: "AdminManage",
  components: {MyEditor},
  data() {
    return {
      isEdit: false,
      showIndex: '3',
      currentPage: 1,
      newsList: [
        {
          date: '14',
          month: '2023-12',
          title: '平常的调研，不平常的部署',
          text: '应中南大学邹滨教授邀请，湖南省生态环境厅环境监测处处长金杰坤、湖南省生态环境监测中心主任余涛、湖南省生态环境厅环境监测处副处长丁华、湖南省生态环境监测中心生态部部长易敏、湖南省生态环境监测中心大气部部长郭卉等一行……',
          img: require('@/assets/images/img_2.png')
        },{
          date: '12',
          month: '2023-10',
          title: '事关重大部署，书记亲临现场主持项目验收',
          text: '2023年10月12日，应项目课题组邀请，常德市自然资源和规划局党组书记、局长宋磊，常德市自然资源和规划局副局长张辉，常德市自然资源和规划局办公室主任唐家新等领导专家一行5人亲临省会长沙听取了“常德市碳汇监测试点”项目成果验收汇报"……',
          img: require("../assets/images/img_4.png")
        },{
          date: '12',
          month: '2023-07',
          title: '用真技术赢得客户信任',
          text: '应中国环境监测总站邀请，我司首席科学家、中南大学地球科学与信息物理学院邹滨教授及其科研骨干成员等一行前往临湘市调研大气污染防治工作进展情况，我司研究院院长郑超应邀随同参与了本次调研交流会……',
          img: require("@/assets/images/img_3.png")
        }
      ],
      isCollapse: false,
      activeMenu: '3',
      fileList: [],
      imageBase64: '',
      form: {
        title: '',
        zhaiyao: '',
        content: '',
        suoluetu: '',
        pubTime: ''
      },
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            // 后端上传地址，必填
            server: "/dev-api/common/upload",

            timeout: 5 * 1000, // 5s 超时时间

            fieldName: 'custom-fileName',

            //选择文件时的类型限制，默认为['image/*'] 如不想限制，则设置为 []
            allowedFileTypes: ['image/*'],

            metaWithUrl: true, // 参数拼接到 url 上

            maxFileSize: 1000 * 1024 * 1024, //1g //设置大点 不然图片过大会报错

            base64LimitSize: 1000000 * 1024, // 1g 以下插入 base64

            // 上传前
            onBeforeUpload(file) {
              console.log('onBeforeUpload', file)
              // Message({
              //                 message: '图片正在上传中,请耐心等待',
              //                 duration: 0,
              //                 customClass: 'uploadTip',
              //                 iconClass: 'el-icon-loading',
              //                 showClose: true
              //               });
              return file.url // 返回哪些文件可以上传
              // return false 会阻止上传
            },
            // uploadImage: {   //上传图片配置
            //   customUpload: handleUpload
            // },
            // uploadVideo: {  //上传视频配置
            //   customUpload: handleUpload
            // }
          },

          // 上传进度的回调函数
          onProgress(progress) {
            console.log('onProgress', progress)
          },
          // 单个文件上传成功之后
          onSuccess(file, res) {
            console.log('onSuccess', file.url, res)
          },
          // 单个文件上传失败
          onFailed(file, res) {
            alert(res.message)
            console.log('onFailed', file, res)
          },
          // 上传错误，或者触发 timeout 超时
          onError(file, err, res) {
            alert(err.message)
            console.error('onError', file, err, res)
          },
        },
      },
      mode: 'default', // or 'simple'
    }
  },
  methods: {
    handleOpen(key, keyPath) {
    },
    handleClose() {

    },
    handleClick(id) {
      getNews(id).then((res) => {
        console.log(res);
        this.$refs.editor.valueHtml = res.data.content
        this.showIndex = '3'
        this.isEdit = true
        this.form = this.newsList.find(item => item.id === id)
        this.imageBase64 = this.form.img
        this.fileList = [
          {
            url: this.form.img
          }
        ]
      })

      // router.push({ name: 'newsDetail', params: { userId: '123' }})
    },
    handleSelect(index) {
      this.showIndex = index
      switch (index) {
        case '3':
          this.form = {}
          this.imageBase64 = ''
          this.fileList = []
          this.$refs.editor.valueHtml = ''
      }
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },

    async onSubmit() {
      this.form.content = this.$refs.editor.valueHtml;
      // upload(file).then((res) => {
      //   console.log(res);
      // })
      await submitNews(this.form).then((res) => {
        console.log(res);
        ElMessage({
          message: '新闻添加成功',
          type: 'success',
        })
        // ElMessageBox.confirm(
        //   'proxy will permanently delete the file. Continue?',
        //   'Success',
        //   {
        //     confirmButtonText: 'OK',
        //     cancelButtonText: 'Cancel',
        //     type: 'warning',
        //   }
        // )
      })

      await getNewsList("", this.currentPage - 1, 5).then((res) => {
        this.newsList = res.data.data
        console.log(res.data.data);
        this.newsList.forEach(item => {
          item.date = item.pubTime.substring(8, 10)
          item.month = item.pubTime.substring(0, 7)
          item.imageShow = false
          getNewsImage(item.suoluetu).then(res => {
            const url = window.URL.createObjectURL(res)
            item.img = url
            // item.imageShow = true
          })
        })
        this.showIndex = '4'
        this.activeMenu = '4'
      })
      // console.log(this.html);
      // this.$message('submit!')
    },
    async onSave() {
      this.form.content = this.$refs.editor.valueHtml;
      // upload(file).then((res) => {
      //   console.log(res);
      // })
      await updateNews(this.form).then((res) => {
        console.log(res);
        this.newsList = null
        ElMessage({
          type: 'success',
          message: '新闻保存成功',
        })
      })
      await getNewsList("", this.currentPage - 1, 5).then((res) => {
        this.newsList = res.data.data
        console.log(res.data.data);
        this.newsList.forEach(item => {
          item.date = item.pubTime.substring(8, 10)
          item.month = item.pubTime.substring(0, 7)
          item.imageShow = false
          getNewsImage(item.suoluetu).then(res => {
            const url = window.URL.createObjectURL(res)
            item.img = url
            // item.imageShow = true
          })
        })
        this.showIndex = '4'
      })
    },
    async onCancel() {
      ElMessageBox.confirm(
        '确定是否删除此条新闻？',
        'Warning',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(async () => {
        await removeNews(this.form.id).then(res => {
          ElMessage({
            type: 'success',
            message: '新闻删除成功',
          })
        })
        await getNewsList("", this.currentPage - 1, 5).then((res) => {
          this.newsList = res.data.data
          this.newsList.forEach(item => {
            item.date = item.pubTime.substring(8, 10)
            item.month = item.pubTime.substring(0, 7)
            item.imageShow = false
            getNewsImage(item.suoluetu).then(res => {
              const url = window.URL.createObjectURL(res)
              item.img = url
              // item.imageShow = true
            })
          })
          this.showIndex = '4'
        })

      }).catch(() => {
      })

    },
    upimage(file) {
      // console.log(file);
      // upload(file).then((res) => {
      //    console.log(res);
      // })

      // console.log(file);
    },
    handleChange(file, fileList) {
      let formData = new FormData();
      formData.append('file',file.raw);
      upload(formData).then((res) => {
        this.form.suoluetu = res.data
      })
      // let res = this.getBase64(file.raw).then((res) => {
      //   this.form.suoluetu = res
      // })
      // console.log(res);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = {};
        reader.readAsDataURL(file);
        reader.onload = function () {
          fileResult.value = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        }
        reader.onloadend = function () {
          resolve(fileResult.value)
        }
      })
    }
  },
  mounted() {
    if (this.$store.getters['isLogin'] === false) {
      this.$router.push('/login')
    }
    else {
      getNewsList("", this.currentPage - 1, 5).then((res) => {
        this.newsList = res.data.data
        console.log(res.data.data);
        this.newsList.forEach(item => {
          item.date = item.pubTime.substring(8, 10)
          item.month = item.pubTime.substring(0, 7)
          item.imageShow = false
          getNewsImage(item.suoluetu).then(res => {
            const url = window.URL.createObjectURL(res)
            item.img = url
            // item.imageShow = true
          })
        })
      })
      this.$refs.editor.valueHtml = ''
    }
    // setTimeout(() => {
    //   this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    // }, 1500)

  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.center {
    position: relative;
    display: flex;
    flex-direction: row;
    .sidebar-container {
        width: 300px;
        .el-menu-vertical-demo {
            width: 100%;
            height: 100%;
        }
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 300px;
            min-height: 400px;
        }
    }
    .main-container {
        flex-grow: 1;
        padding: 20px;
        /*background-color: blue;*/
        .news-manage-container {
            .news-list {

                .news-item {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    position: relative;
                    padding: 30px;
                    box-sizing: border-box;
                    height: 250px;
                    align-items: center;
                    justify-content: space-between;
                    /*border-top: 1px solid gray;*/
                    .news-date {
                        position: relative;
                        width: 15%;
                        color: #0524CC;
                    }
                    .news-info {
                        position: relative;
                        flex: 1;
                        padding: 0 40px;
                        .news-info-title {
                            font-size: 30px;
                            font-weight: bold;
                            margin-bottom: 30px;
                        }
                        .news-info-text {
                            font-size: 20px;
                            color: #898989;
                            text-align: left;
                        }
                    }
                    .news-img {
                        position: relative;
                        width: 20%;
                        height: 100%;
                    }

                }
                .news-item:hover { cursor:pointer;background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0.05), white); }
                .bottom-line {
                    width: calc(100% - 2px);
                    height: 0;
                    border: 1px solid #898989;;
                }

            }

            .pagination {
                padding: 30px 0;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }
}
</style>